import { populate } from 'populate';import dragonBones from 'pixi-dragonbones';

const raw = {
  className: 'AndroidSettingsMenuLayout',
  width: 640,
  height: 960,
  x: 0,
  y: 0,
  list: [
    {
      id: '79780dad-ff4b-4fee-a00c-cbc6eeb7dd7a',
      type: 'Container',
      name: 'root',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: ''
    },
    {
      id: '892da9d8-d35d-40d8-9b45-5ff0532e66ab',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'popup_background',
      parent: '79780dad-ff4b-4fee-a00c-cbc6eeb7dd7a',
      data: ''
    },
    {
      id: '21cf557c-dae3-4df0-8a14-7cfc5bc8afd2',
      type: 'Text',
      name: 'music_txt',
      nameSpace: '',
      className: '',
      x: -100,
      y: -90,
      anchor: {
        x: 0,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'On',
      localize: true,
      maxWidth: 90,
      maxHeight: 76,
      maxFontSize: 34,
      icons: [],
      style: {
        fontSize: 12,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#bb3e01',
        stroke: '#933019',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 0.9,
        dropShadowAngle: 1.8,
        dropShadowBlur: 0,
        dropShadowColor: '#b83500',
        dropShadowDistance: 3,
        leading: -15,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '79780dad-ff4b-4fee-a00c-cbc6eeb7dd7a',
      data: ''
    },
    {
      id: 'c6fe1b0c-ff41-49b7-8abd-c682cc354624',
      type: 'Text',
      name: 'sound_txt',
      nameSpace: '',
      className: '',
      x: 189,
      y: -90,
      anchor: {
        x: 0,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'On',
      localize: true,
      maxWidth: 90,
      maxHeight: 76,
      maxFontSize: 34,
      icons: [],
      style: {
        fontSize: 12,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#bb3e01',
        stroke: '#933019',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 0.9,
        dropShadowAngle: 1.8,
        dropShadowBlur: 0,
        dropShadowColor: '#b83500',
        dropShadowDistance: 3,
        leading: -15,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '79780dad-ff4b-4fee-a00c-cbc6eeb7dd7a',
      data: ''
    },
    {
      id: '98a02c5b-b071-4a8f-a6af-b86e18995509',
      type: 'Sprite',
      name: 'return_btn',
      nameSpace: '',
      className: '',
      x: 0,
      y: 315,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'button_medium_green',
      parent: '79780dad-ff4b-4fee-a00c-cbc6eeb7dd7a',
      data: ''
    },
    {
      id: '2f77db20-a746-4235-a51d-c5b704e5bd2a',
      type: 'Sprite',
      name: 'exit_level_btn',
      nameSpace: '',
      className: '',
      x: 0,
      y: 315,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'button_medium_red',
      parent: '79780dad-ff4b-4fee-a00c-cbc6eeb7dd7a',
      data: ''
    },
    {
      id: 'fec39824-120a-4e63-855f-fb22b6d8e156',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: -291,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'popup_title_bg',
      parent: '79780dad-ff4b-4fee-a00c-cbc6eeb7dd7a',
      data: ''
    },
    {
      id: 'ab6b723f-b1fb-4b15-a345-503760caadc8',
      type: 'Text',
      name: 'header_txt',
      nameSpace: '',
      className: '',
      x: 0,
      y: -297,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Settings',
      localize: true,
      maxWidth: 420,
      maxHeight: 78,
      maxFontSize: 44,
      icons: [],
      style: {
        fontSize: 29,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffff',
        stroke: '#933019',
        strokeThickness: 4,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 0.9,
        dropShadowAngle: 1.8,
        dropShadowBlur: 0,
        dropShadowColor: '#b83500',
        dropShadowDistance: 3,
        leading: -15,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '79780dad-ff4b-4fee-a00c-cbc6eeb7dd7a',
      data: ''
    },
    {
      id: '8b7bbd41-8325-4a1b-b9f3-aa9637c91934',
      type: 'Text',
      name: 'music_title_txt',
      nameSpace: '',
      className: '',
      x: -160,
      y: -185,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'audioMusic',
      localize: true,
      maxWidth: 225,
      maxHeight: 80,
      maxFontSize: 40,
      icons: [],
      style: {
        fontSize: 40,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffff',
        stroke: '#ab3145',
        strokeThickness: 6,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 0.9,
        dropShadowAngle: 1.8,
        dropShadowBlur: 0,
        dropShadowColor: '#ab3145',
        dropShadowDistance: 4,
        leading: -15,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '79780dad-ff4b-4fee-a00c-cbc6eeb7dd7a',
      data: ''
    },
    {
      id: '48d9d833-891c-4cd5-a8e7-aa60cf0f981b',
      type: 'Text',
      name: 'sound_title_txt',
      nameSpace: '',
      className: '',
      x: 128,
      y: -185,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'audioSfx',
      localize: true,
      maxWidth: 225,
      maxHeight: 80,
      maxFontSize: 40,
      icons: [],
      style: {
        fontSize: 40,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffff',
        stroke: '#ab3145',
        strokeThickness: 6,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 0.9,
        dropShadowAngle: 1.8,
        dropShadowBlur: 0,
        dropShadowColor: '#ab3145',
        dropShadowDistance: 4,
        leading: -15,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '79780dad-ff4b-4fee-a00c-cbc6eeb7dd7a',
      data: ''
    },
    {
      id: 'af77e026-c166-4f2d-8551-13356e253cf1',
      type: 'Sprite',
      name: 'close_btn',
      nameSpace: '',
      className: '',
      x: 335,
      y: -246,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'button_close',
      parent: '79780dad-ff4b-4fee-a00c-cbc6eeb7dd7a',
      data: ''
    },
    {
      id: 'd005963a-4777-4cc4-825d-16013e4aa74a',
      type: 'Sprite',
      name: 'music_btn',
      nameSpace: '',
      className: '',
      x: -165,
      y: -90,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'audiomusic_1_2',
      parent: '79780dad-ff4b-4fee-a00c-cbc6eeb7dd7a',
      data: ''
    },
    {
      id: 'ee9d9d9f-4551-44ab-8bd6-d15ded7a24ac',
      type: 'Sprite',
      name: 'sound_btn',
      nameSpace: '',
      className: '',
      x: 121,
      y: -90,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'audiosfx_1_2',
      parent: '79780dad-ff4b-4fee-a00c-cbc6eeb7dd7a',
      data: ''
    },
    {
      id: '24e57d1f-edcd-4e88-8833-9b529020138f',
      type: 'Text',
      name: 'user_id_header',
      nameSpace: '',
      className: '',
      x: -145,
      y: 160,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'UserId',
      localize: true,
      maxWidth: 240,
      maxHeight: 50,
      maxFontSize: 28,
      icons: [],
      style: {
        fontSize: 24,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#bb3e01',
        stroke: '#933019',
        strokeThickness: 0,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 0.9,
        dropShadowAngle: 1.8,
        dropShadowBlur: 0,
        dropShadowColor: '#b83500',
        dropShadowDistance: 3,
        leading: -15,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '79780dad-ff4b-4fee-a00c-cbc6eeb7dd7a',
      data: ''
    },
    {
      id: 'aa37041c-8484-4fe9-b828-e105a64572f3',
      type: 'Sprite',
      name: 'settings_bg',
      nameSpace: '',
      className: '',
      x: 50,
      y: 160,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'settingsidplace',
      parent: '79780dad-ff4b-4fee-a00c-cbc6eeb7dd7a',
      data: ''
    },
    {
      id: 'e037a902-27f4-44f9-be7e-b1add458e407',
      type: 'Text',
      name: 'user_id_txt',
      nameSpace: '',
      className: '',
      x: 50,
      y: 160,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '2431109430338731',
      localize: false,
      maxWidth: 235,
      maxHeight: 35,
      maxFontSize: 24,
      icons: [],
      style: {
        fontSize: 24,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#8a352a',
        stroke: '#8a352a',
        strokeThickness: 0,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 0.9,
        dropShadowAngle: 1.8,
        dropShadowBlur: 0,
        dropShadowColor: '#b83500',
        dropShadowDistance: 1,
        leading: -15,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '79780dad-ff4b-4fee-a00c-cbc6eeb7dd7a',
      data: ''
    },
    {
      id: 'c409718f-3d24-4103-bcdd-a25093f6ee53',
      type: 'Text',
      name: 'version_txt',
      nameSpace: '',
      className: '',
      x: 0,
      y: 207,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Version',
      localize: true,
      maxWidth: 275,
      maxHeight: 66,
      maxFontSize: 30,
      icons: [],
      style: {
        fontSize: 12,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#bb3b2f',
        stroke: '#bb3b2f',
        strokeThickness: 0,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 0.9,
        dropShadowAngle: 1.8,
        dropShadowBlur: 0,
        dropShadowColor: '#b83500',
        dropShadowDistance: 3,
        leading: -15,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '79780dad-ff4b-4fee-a00c-cbc6eeb7dd7a',
      data: ''
    },
    {
      id: '68832645-1b1e-45f2-a0e9-71520cbfaeba',
      type: 'Container',
      name: 'fb_connected',
      nameSpace: 'fbconnected_wrap',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: false,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '79780dad-ff4b-4fee-a00c-cbc6eeb7dd7a',
      data: ''
    },
    {
      id: 'af6f663d-9d4f-44f8-b330-c95f649bd600',
      type: 'Container',
      name: 'cloud_wrap',
      nameSpace: 'cloudsave_wrap',
      className: '',
      x: 0,
      y: -21,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '79780dad-ff4b-4fee-a00c-cbc6eeb7dd7a',
      data: ''
    },
    {
      id: '4f8bc6ee-ea66-4222-aa64-6a9f205f6d54',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 115,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'solitairefarm@softgames.de',
      localize: false,
      maxWidth: 310,
      maxHeight: 66,
      maxFontSize: 30,
      icons: [],
      style: {
        fontSize: 11,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#8a352a',
        stroke: '#8a352a',
        strokeThickness: 0,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 0.9,
        dropShadowAngle: 1.8,
        dropShadowBlur: 0,
        dropShadowColor: '#b83500',
        dropShadowDistance: 1,
        leading: -15,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '79780dad-ff4b-4fee-a00c-cbc6eeb7dd7a',
      data: ''
    },
    {
      id: 'acde098a-79b2-4995-8a11-3eef1def8e92',
      type: 'Text',
      name: 'return_txt',
      nameSpace: 'returntxt',
      className: '',
      x: 0,
      y: -6,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Return',
      localize: true,
      maxWidth: 140,
      maxHeight: 70,
      maxFontSize: 51,
      icons: [],
      style: {
        fontSize: 51,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffff',
        stroke: '#074829',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '98a02c5b-b071-4a8f-a6af-b86e18995509',
      data: ''
    },
    {
      id: '36092177-150d-4baa-8153-5cec83749d38',
      type: 'Text',
      name: 'exit_level_txt',
      nameSpace: 'exitleveltxt',
      className: '',
      x: 0,
      y: -6,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'EndLevelCaps',
      localize: true,
      maxWidth: 175,
      maxHeight: 70,
      maxFontSize: 51,
      icons: [],
      style: {
        fontSize: 51,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffff',
        stroke: '#81242c',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 140,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '2f77db20-a746-4235-a51d-c5b704e5bd2a',
      data: ''
    },
    {
      id: '82f5bae1-b0bc-449a-85fb-2570034e1b4f',
      type: 'Sprite',
      name: 'fb_connected_btn',
      nameSpace: '',
      className: '',
      x: 0,
      y: 62,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'fb_connect_btn_large',
      parent: '68832645-1b1e-45f2-a0e9-71520cbfaeba',
      data: ''
    },
    {
      id: 'bf62415b-9cee-40cd-8240-08e2f16ee7b3',
      type: 'Text',
      name: 'connected_as',
      nameSpace: '',
      className: '',
      x: 80,
      y: 35,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'ConnectedAs',
      localize: true,
      maxWidth: 195,
      maxHeight: 37,
      maxFontSize: 20,
      icons: [],
      style: {
        fontSize: 51,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffff',
        stroke: '#2d548f',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '68832645-1b1e-45f2-a0e9-71520cbfaeba',
      data: ''
    },
    {
      id: 'af3fdb2d-0aeb-4a44-9eb9-229062745fef',
      type: 'Text',
      name: 'user_name',
      nameSpace: '',
      className: '',
      x: 81,
      y: 70,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Joe',
      localize: false,
      maxWidth: 171,
      maxHeight: 50,
      maxFontSize: 65,
      icons: [],
      style: {
        fontSize: 51,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffff',
        stroke: '#2d548f',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '68832645-1b1e-45f2-a0e9-71520cbfaeba',
      data: ''
    },
    {
      id: 'c85c49e5-bf70-4de6-9336-495270877c3f',
      type: 'Sprite',
      name: 'avatar',
      nameSpace: '',
      className: '',
      x: -55,
      y: 62,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.83,
        y: 0.83
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'no_avatar',
      parent: '68832645-1b1e-45f2-a0e9-71520cbfaeba',
      data: ''
    },
    {
      id: '646f1253-0139-466d-a11d-bc04e914d483',
      type: 'Sprite',
      name: 'avatar_bg',
      nameSpace: '',
      className: '',
      x: -55,
      y: 62,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'avatar_holder',
      parent: '68832645-1b1e-45f2-a0e9-71520cbfaeba',
      data: ''
    },
    {
      id: '313c2e0e-dd4b-4ed5-878b-ac9543a78f07',
      type: 'Sprite',
      name: 'fb_connect_btn',
      nameSpace: '',
      className: '',
      x: 185,
      y: 60,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'fb_connect_btn_medium',
      parent: 'af6f663d-9d4f-44f8-b330-c95f649bd600',
      data: ''
    },
    {
      id: '67a42001-37d4-4002-9a28-1934818501b2',
      type: 'Sprite',
      name: 'gp_connect_btn',
      nameSpace: '',
      className: '',
      x: -185,
      y: 60,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'google_play_connect_btn',
      parent: 'af6f663d-9d4f-44f8-b330-c95f649bd600',
      data: ''
    },
    {
      id: 'daa1a781-6389-412c-8299-77d76196d402',
      type: 'Sprite',
      name: 'gb_disconnect_btn',
      nameSpace: '',
      className: '',
      x: -180,
      y: 108,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'google_play_disconnect',
      parent: 'af6f663d-9d4f-44f8-b330-c95f649bd600',
      data: ''
    },
    {
      id: 'c7992c61-a3bd-409d-8b6c-b35889ae0392',
      type: 'Text',
      name: 'fbconnected_to_txt',
      nameSpace: '',
      className: '',
      x: 38,
      y: -23,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'ConnectTo',
      localize: true,
      maxWidth: 146,
      maxHeight: 30,
      maxFontSize: 16,
      icons: [],
      style: {
        fontSize: 34,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffff',
        stroke: '#2d548f',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '313c2e0e-dd4b-4ed5-878b-ac9543a78f07',
      data: ''
    },
    {
      id: 'baa6998d-7147-4d62-8230-8a92b139ba89',
      type: 'Text',
      name: 'user_name',
      nameSpace: '',
      className: '',
      x: 35,
      y: 7,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Facebook',
      localize: false,
      maxWidth: 165,
      maxHeight: 50,
      maxFontSize: 69,
      icons: [],
      style: {
        fontSize: 51,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffff',
        stroke: '#2d548f',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '313c2e0e-dd4b-4ed5-878b-ac9543a78f07',
      data: ''
    },
    {
      id: 'e01e329c-4922-40a9-8c94-134ac93e3927',
      type: 'Text',
      name: 'gpconnected_to_txt',
      nameSpace: '',
      className: '',
      x: 25,
      y: -23,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'ConnectTo',
      localize: true,
      maxWidth: 146,
      maxHeight: 30,
      maxFontSize: 16,
      icons: [],
      style: {
        fontSize: 34,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffff',
        stroke: '#000000',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '67a42001-37d4-4002-9a28-1934818501b2',
      data: ''
    },
    {
      id: '90b677d2-01a3-44e8-af30-da86c84b3e64',
      type: 'Text',
      name: 'gp_user_name',
      nameSpace: '',
      className: '',
      x: 25,
      y: 6,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Google Play',
      localize: false,
      maxWidth: 165,
      maxHeight: 50,
      maxFontSize: 69,
      icons: [],
      style: {
        fontSize: 51,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffff',
        stroke: '#000000',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '67a42001-37d4-4002-9a28-1934818501b2',
      data: ''
    },
    {
      id: '9d988095-c878-4a5f-ac36-e52435962f4b',
      type: 'Text',
      name: 'disconnect_txt',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Disconnect',
      localize: true,
      maxWidth: 146,
      maxHeight: 30,
      maxFontSize: 16,
      icons: [],
      style: {
        fontSize: 34,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#5b76ab',
        stroke: '#151e2e',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'daa1a781-6389-412c-8299-77d76196d402',
      data: ''
    }
  ],
  version: '1.0.x'
} as const;

export class AndroidSettingsMenuLayout {
  static raw = raw;
  root: PIXI.Container
  music_txt: PIXI.Text
  sound_txt: PIXI.Text
  return_btn: PIXI.Sprite
  return_txt: PIXI.Text
  exit_level_btn: PIXI.Sprite
  exit_level_txt: PIXI.Text
  header_txt: PIXI.Text
  music_title_txt: PIXI.Text
  sound_title_txt: PIXI.Text
  close_btn: PIXI.Sprite
  music_btn: PIXI.Sprite
  sound_btn: PIXI.Sprite
  user_id_header: PIXI.Text
  settings_bg: PIXI.Sprite
  user_id_txt: PIXI.Text
  version_txt: PIXI.Text
  fb_connected: PIXI.Container
  cloud_wrap: PIXI.Container
  returntxt: {}
  exitleveltxt: {}
  fbconnected_wrap: {
    fb_connected_btn: PIXI.Sprite
    connected_as: PIXI.Text
    user_name: PIXI.Text
    avatar: PIXI.Sprite
    avatar_bg: PIXI.Sprite
    children: (PIXI.Sprite | PIXI.Text)[]
  }
  cloudsave_wrap: {
    fb_connect_btn: PIXI.Sprite
    fbconnected_to_txt: PIXI.Text
    user_name: PIXI.Text
    gp_connect_btn: PIXI.Sprite
    gpconnected_to_txt: PIXI.Text
    gp_user_name: PIXI.Text
    gb_disconnect_btn: PIXI.Sprite
    disconnect_txt: PIXI.Text
    children: (PIXI.Sprite)[]
  }

  constructor() {
    populate(this, raw);
  }
}
